var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgKey = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.3335 4.99992L12.6669 2.66659M14.0002 1.33325L12.6669 2.66659L14.0002 1.33325ZM7.59352 7.73992C7.93774 8.07956 8.21139 8.48394 8.39869 8.92978C8.58599 9.37561 8.68325 9.8541 8.68487 10.3377C8.68649 10.8213 8.59244 11.3004 8.40813 11.7475C8.22382 12.1945 7.95289 12.6007 7.61095 12.9427C7.269 13.2846 6.8628 13.5556 6.41572 13.7399C5.96864 13.9242 5.48952 14.0182 5.00594 14.0166C4.52236 14.015 4.04388 13.9177 3.59804 13.7304C3.15221 13.5431 2.74783 13.2695 2.40818 12.9253C1.74027 12.2337 1.37069 11.3075 1.37904 10.3461C1.3874 9.38473 1.77302 8.46508 2.45285 7.78525C3.13268 7.10542 4.05232 6.7198 5.01371 6.71145C5.9751 6.70309 6.90131 7.07267 7.59285 7.74059L7.59352 7.73992ZM7.59352 7.73992L10.3335 4.99992L7.59352 7.73992ZM10.3335 4.99992L12.3335 6.99992L14.6669 4.66659L12.6669 2.66659L10.3335 4.99992Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/key.3bcd81e8.svg";
export { ForwardRef as ReactComponent };